import { AddFilled } from "@fluentui/react-icons";

interface TeamCreateButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const TeamCreateButton = ({
  onClick,
  disabled = false,
}: TeamCreateButtonProps) => (
  <button
    className={`border-bzd-purple-300 mb-4 flex w-full items-center gap-2 rounded-md border-2 border-dashed bg-transparent p-4 transition-colors ${
      disabled
        ? "cursor-not-allowed opacity-50"
        : "hover:bg-bzd-purple-50 cursor-pointer"
    }`}
    disabled={disabled}
    onClick={onClick}
    type="button"
  >
    <div className="bg-bzd-purple-300 flex size-6 items-center justify-center rounded-md">
      <AddFilled className="size-4 text-white" />
    </div>
    <span className="text-bzd-purple-300 text-left text-lg font-medium">
      Create new team
    </span>
  </button>
);
